const SERVER_BASE_URL = () => {
  //
  if (
    !process.env.NODE_ENV ||
    process.env.NODE_ENV === 'development' ||
    process.env.NEXT_PUBLIC_DEBUG === 'True' ||
    (typeof window !== 'undefined' && window.Cypress)
  ) {
    return `http://localhost:8000/schools/public`;
  }
  if (process.env.NEXT_PUBLIC_DEPLOY_ENVIRONMENT == `PRODUCTION`) {
    return `https://api.shulesuite.com/schools/public`;
  }
  return `https://staging.api.shulesuite.com/schools/public`;
  // return "http://localhost:8000";
};
export default SERVER_BASE_URL;
export const BASE_URL = SERVER_BASE_URL();
export const API_URL = `${BASE_URL}/api`;
